import axiosInstance from '../../helpers/axiosInstance'


export default function getOcupacionesService () {
    return axiosInstance.get("ocupaciones")
        .then(response => response.data)
        .catch(error => {
          throw error;
        });
}